import React from 'react';
import { Button } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useUpdateWorkflowMutation } from '../../../../../services/WorkflowService';

interface SaveWorkflowButtonProps {
  onClick: () => void;
}

export const SaveWorkflowButton: React.FC<SaveWorkflowButtonProps> = ({ onClick }) => {
  const [, { isLoading }] = useUpdateWorkflowMutation();

  return (
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={onClick}
      disabled={isLoading}
      sx={{
        backgroundColor: '#162346',
        '&:hover': { backgroundColor: '#1a2a52' },
        fontWeight: 600,
      }}
    >
      {isLoading ? 'Saving...' : 'Save Changes'}
    </Button>
  );
};

export default SaveWorkflowButton;
